import _defineProperty from "@babel/runtime/helpers/defineProperty";
import classnames from 'classnames';
import React from 'react';
import { Check } from '@tencent/adp-icons-react';
import { useMemoizedFn } from 'ahooks';
import { message } from '@tencent/spaui';
var clsPrefix = 'zhb-steps';
var finishNode = React.createElement(Check, {
  size: 12
});
var getIndicator = function getIndicator(option) {
  var _option$item = option.item,
    status = _option$item.status,
    indicatorText = _option$item.indicatorText,
    itemIdx = option.itemIdx,
    stepIndex = option.stepIndex;
  var nextIndicatorText = indicatorText || itemIdx + 1;
  if (status != null) {
    if (status === 'finish') {
      return finishNode;
    }
    if (status === 'process' || status === 'init') {
      return nextIndicatorText;
    }
    var notReach = status;
    message.error('内部错误: status not reach', notReach);
  }
  return itemIdx < stepIndex ? finishNode : nextIndicatorText;
};
export var ZhbSteps = function ZhbSteps(props) {
  var dts = props.dts,
    _props$stepIndex = props.stepIndex,
    stepIndex = _props$stepIndex === void 0 ? 0 : _props$stepIndex,
    size = props.size,
    className = props.className,
    style = props.style,
    stepClickable = props.stepClickable,
    onStepChange = props.onStepChange;
  var stepClick = useMemoizedFn(function (index) {
    if (!stepClickable) {
      return;
    }
    onStepChange === null || onStepChange === void 0 ? void 0 : onStepChange(index);
  });
  return React.createElement("ul", {
    className: classnames(clsPrefix, className, "".concat(clsPrefix, "-").concat(size)),
    style: style
  }, dts.map(function (item, idx) {
    return React.createElement("li", {
      key: "".concat(item.title, "_").concat(idx),
      className: classnames(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(clsPrefix, "-item"), true), "".concat(clsPrefix, "-item-").concat(idx), true), "".concat(clsPrefix, "-item-clickable"), stepClickable), "".concat(clsPrefix, "-item-active"), stepIndex === idx || item.status === 'process'), "".concat(clsPrefix, "-item-actived"), item.status !== 'init' && idx < stepIndex)),
      onClick: function onClick() {
        return stepClick(idx);
      }
    }, React.createElement("span", {
      className: "".concat(clsPrefix, "-indicator")
    }, getIndicator({
      stepIndex: stepIndex,
      itemIdx: idx,
      item: item
    })), React.createElement("div", {
      className: "".concat(clsPrefix, "-info")
    }, React.createElement("div", {
      className: "".concat(clsPrefix, "-info-title-wrap")
    }, item.title && React.createElement("div", {
      className: "".concat(clsPrefix, "-info-title")
    }, item.title), idx < dts.length - 1 && React.createElement("div", {
      className: "".concat(clsPrefix, "-line-wrap")
    }, "\xA0")), item.desc && React.createElement("div", {
      className: "".concat(clsPrefix, "-info-desc")
    }, item.desc)));
  }));
};